import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpErrorResponse, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../modules/auth';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthHeaderInterceptor implements HttpInterceptor {
    constructor(private router: Router, private injector: Injector) {}

    logout() {
        const auth = this.injector.get(AuthService);
        auth.isExpired = true;
        auth.logout();
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Resolve and compare origins and path boundaries, not URL string prefixes.
        const url = new URL(req.url, window.location.origin);
        const api = new URL(environment.apiUrl, window.location.origin);
        const apiPath = api.pathname.replace(/\/+$/, '');
        if (url.origin !== api.origin ||
            (url.pathname !== apiPath && !url.pathname.startsWith(`${apiPath}/`))) {
            return next.handle(req);
        }

        let authToken: string | undefined;
        try {
            const key = `${environment.appVersion}-${environment.USERDATA_KEY}`;
            const stored = JSON.parse(localStorage.getItem(key) || '{}');
            authToken = typeof stored?.authToken === 'string' ? stored.authToken : undefined;
        } catch {
            // Corrupt browser storage must not prevent login or public API requests.
        }
        if (!authToken) {
            return next.handle(req);
        }
        const authReq = req.clone({ setHeaders: { Authorization: `Bearer ${authToken}` } });
        return next.handle(authReq).pipe(catchError(err => {
            // 401 = session no longer valid (expired, deactivated or deleted user): back to /auth/login.
            // 403 is a business "forbidden" (e.g. client outside scope) and must not end the session.
            if (err instanceof HttpErrorResponse && err.status === 401) {
                this.logout();
            }
            return throwError(() => err);
        }));
    }
}
